// extracted by mini-css-extract-plugin
export var container = "_di-0";
export var infoIcon = "_di-2";
export var titleRowCol = "_di-1";